import {useEffect, useState} from 'react'
import {useOccupancy} from '../../../../hooks/useOccupancy'
import {ViewOccupancyLayout} from '../../../ocupability/components/ViewOccupancyLayout'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {getRoomByIdService} from '../../services/getRoomById.service'

type SelectionRecord = {
  company?: string | number
  client?: string | number
  site?: string | number
  camp?: string | number
  mod?: string | number
  pis?: string | number
  hbt?: string | number
}

export const OccupancyLayout = () => {
  const [selectedOption, setSelectedOption] = useState<SelectionRecord>({})
  const [selectedOptionName] = useState<SelectionRecord>({})
  const {layoutData, getLayoutList, setLayoutData, TipoData, setTipoData} = useOccupancy()
  const {currentTabItem} = useHoteleria()
  const {idToEdit} = currentTabItem

  const getDataLoad = async () => {
    try {
      const {
        data: {data},
      } = await getRoomByIdService(idToEdit as any)
      const {CompaniaId, ClienteId, SiteId, CampamentoId, ModuloId, NivelId, Id} = data

      console.log(data)

      setSelectedOption((prevSelectedOption) => ({
        ...prevSelectedOption,
        company: CompaniaId,
        client: ClienteId,
        site: SiteId,
        camp: CampamentoId,
        mod: ModuloId,
        pis: NivelId,
        hbt: Id,
      }))
    } catch (error) {}

    // setSelectedOptionName((prevSelectedOptionName) => ({
    //   ...prevSelectedOptionName,
    //   mod: 'Pisos',
    // }))
  }

  const loadBedsLayout = () => {
    let TipoDataIn = 'CAM'
    setTipoData(TipoDataIn)
    setLayoutData([])
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: selectedOption.camp,
      ModuloId: selectedOption.mod,
      PisoId: selectedOption.pis,
      HabitacionId: selectedOption.hbt,
    })
  }

  useEffect(() => {
    getDataLoad()
  }, [])

  useEffect(() => {
    if (selectedOption['hbt'] && selectedOption['hbt'] !== '0') {
      loadBedsLayout()
    }
  }, [selectedOption.hbt])
  return (
    <div className='sdx_form card p-4'>
      <ViewOccupancyLayout
        data={layoutData}
        selectedOptionName={selectedOptionName}
        selectedOption={selectedOption}
        tipoData={TipoData}
        loadFloorsLayout={() => {}}
        loadHabiationsLayout={() => {}}
        loadBedsLayout={loadBedsLayout}
      />
    </div>
  )
}
